<template>
    <v-card>
        <v-layout>
            <v-flex xs12>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Products</h1>
                    </v-flex>
                </v-layout>
                <v-layout wrap>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Filter Products"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm3 offset-sm1>
                        <v-checkbox
                            label="Active Only"
                            v-model="activeOnly"
                        ></v-checkbox>
                    </v-flex>
                    <v-flex xs12 sm2 offset-sm1>
                        <v-btn
                            color="success"
                            block
                            @click="editProduct({ Active: true })"
                        >
                            Add
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-data-table
                            :headers="headers"
                            :items="products"
                            :loading="loading"
                            :search="search"
                            must-sort
                            :rows-per-page-items="rowsPerPage"
                            :pagination.sync="pagination"
                        >
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <tr :data-id="props.item.ID">
                                    <td>{{props.item.CategoryName}}</td>
                                    <td>{{props.item.Name}}</td>
                                    <td>{{formatCurrency(props.item.CostPrice)}}</td>
                                    <td>{{formatCurrency(props.item.SellPrice)}}</td>
                                    <td>{{formatCurrency(props.item.CostPerUnit)}}</td>
                                    <td>{{props.item.Quantity}}</td>
                                    <td v-if="props.item.Active"><v-icon color="success">check</v-icon></td>
                                    <td v-if="!props.item.Active"><v-icon color="error">close</v-icon></td>
                                    <td>
                                        <v-btn
                                            color="warning"
                                            block
                                            @click="editProduct(props.item)"
                                        >
                                            Edit
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                            <template v-if="!loading" slot="no-data">
                                <v-alert v-if="loadError" outline :value="true" color="error" icon="error">
                                    {{loadError}}
                                </v-alert>
                                <v-alert v-if="!loadError" outline :value="true" type="info">
                                    No results found
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-dialog v-model="showEditDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark :disabled="saving" @click="cancelEditProduct">
                            <v-icon large>close</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-title v-if="editedProduct && editedProduct.ID">Edit Product</v-toolbar-title>
                        <v-toolbar-title v-else>Add New Product</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-form ref="editForm" v-model="editProductValid">
                        <v-layout class="dialog-content">
                            <v-flex xs12 md6 offset-md3>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-autocomplete
                                            :items="departments"
                                            item-text="Name"
                                            item-value="ID"
                                            v-model="selectedDepartment"
                                            label="Department"
                                            hint="Department"
                                            @change="departmentChanged"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-autocomplete
                                            :items="filteredCategories"
                                            item-text="Name"
                                            item-value="ID"
                                            v-model="editedProduct.CategoryID"
                                            label="Category"
                                            hint="Category"
                                            :rules="[rules.selectIDRequired]"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable
                                            counter="100"
                                            maxlength="100"
                                            v-model="editedProduct.Name"
                                            :rules="[rules.required]"
                                            label="Product Name">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable
                                            maxlength="100"
                                            v-model="editedProduct.CostPrice"
                                            :rules="[rules.numericOrEmpty]"
                                            prepend-icon="attach_money"
                                            @change="calculateCostPerUnit"
                                            label="Cost Price">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable
                                            maxlength="100"
                                            v-model="editedProduct.SellPrice"
                                            :rules="[rules.numericOrEmpty]"
                                            prepend-icon="attach_money"
                                            label="Sell Price">
                                        </v-text-field>
                                    </v-flex>
                                     <v-flex xs12>
                                        <v-text-field
                                            clearable
                                            maxlength="100"
                                            v-model="editedProduct.CostPerUnit"
                                            :rules="[rules.numericOrEmpty]"
                                            prepend-icon="attach_money"
                                            label="Cost Per Unit">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable
                                            mask="######"
                                            v-model="editedProduct.Quantity"
                                            :rules="[rules.numericOrEmpty]"
                                            @change="calculateCostPerUnit"
                                            label="Quantity(Unit)">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea
                                            clearable
                                            counter="2000"
                                            maxlength="2000"
                                            v-model="editedProduct.ProductComment"
                                            label="Product Comment">
                                        </v-textarea>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable
                                            counter="200"
                                            maxlength="200"
                                            v-model="editedProduct.UnitOfMeasure"
                                            :rules="[rules.required]"
                                            label="Unit Of Measure">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            clearable
                                            maxlength="50"
                                            v-model="editedProduct.ProductIDCode"
                                            label="Product ID Code">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-checkbox label="Active" v-model="editedProduct.Active"></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap class="dialog-action-buttons">
                                    <v-flex xs12 sm6>
                                        <v-btn block color="error" :disabled="saving" @click="cancelEditProduct">Cancel</v-btn>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-btn block color="success" :disabled="!editProductValid" :loading="saving" @click="saveEditedProduct">Save</v-btn>
                                    </v-flex>
                                    <v-flex xs12>
                                        <error-alert :content="saveError" :display="saveError"></error-alert>
                                    </v-flex>
                                </v-layout>                            
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import formatters from "../../helpers/formatters";
import ErrorAlert from "../common/ErrorAlert"
import util from '@/services/util';
import _ from "underscore";

export default {
    components: {
        ErrorAlert
    },
    props: [
        
    ],
    data() {
        return {
            rowsPerPage: [20, 50, 100],
            pagination: {
                rowsPerPage: 20, // default
                sortBy: "CategorySortOrder"
            },
            editedProduct: {},
            selectedDepartment: -1,
            showEditDialog: false,
            editProductValid: false,
            search: "",
            activeOnly: true,
            rules: validationRules.rules,
            headers: [
                {
                    text: "Category",
                    value: "CategoryName"
                },
                {
                    text: "Name",
                    value: "Name"
                },
                {
                    text: "Cost Price",
                    value: "CostPrice"
                },
                {
                    text: "Sell Price",
                    value: "SellPrice"
                },
                {
                    text: "Cost Per Unit",
                    value: "CostPerUnit"
                },
                {
                    text: "Quantity",
                    value: "Quantity"
                },
                {
                    text: "Active",
                    value: "Active"
                },
                {
                    text: "", // edit button
                    sortable: false
                }
            ]
        };
    },
    computed: {
        loading() {
            return this.$store.state.productStore.loading;
        },
        loadError() {
            return this.$store.state.productStore.loadError;
        },
        saving() {
            return this.$store.state.productStore.saving;
        },
        saveError() {
            return this.$store.state.productStore.saveError;
        },
        products() {
            return this.$store.state.productStore.products.filter(s => s.Active || !this.activeOnly);
        },
        categories() {
            return this.$store.state.categoryStore.categories.filter(c => c.Active);
        },
        filteredCategories() {
            return this.categories.filter(x => _.some(x.Departments, function(y) { return y.DepartmentID == this.selectedDepartment }, this) || this.selectedDepartment == -1).sort((a, b) => {
                if(a.SortOrder > b.SortOrder) {
                    return 1
                } else if(a.SortOrder < b.SortOrder) {
                    return -1
                } else {
                    if(a.Name > b.Name) {
                        return 1
                    } else if (a.Name < b.Name) {
                        return -1
                    } else {
                        return 0
                    }
                }
            });
        },
        departments() {
            return this.$store.state.departmentStore.departments.filter(s => s.Active);
        }
    },
    methods: {
        loadProducts() {
            this.$store.dispatch("productStore/loadProducts");
        },
        loadCategories() {
            this.$store.dispatch("categoryStore/loadCategories");
        },
        loadDepartments() {
            this.$store.dispatch("departmentStore/loadDepartments");
        },
        editProduct(item) {
            this.$store.dispatch("productStore/clearSaveError");

            // show which fields are mandatory when opening the edit form
            this.$refs.editForm.validate();

            this.editedProduct = Object.assign({}, item);
            // add department
            if (this.editedProduct.CategoryID){
                this.selectedDepartment = this.$store.state.categoryStore.categories.find(x => x.ID == this.editedProduct.CategoryID).Departments[0].DepartmentID;
            }

            this.showEditDialog = true;
        },
        cancelEditProduct() {
            this.showEditDialog = false;
            this.editedProduct = {};
        },
        saveEditedProduct() {
            var that = this;

            this.$store.dispatch("productStore/saveProduct", {
                product: this.editedProduct,
                finally: function() {
                    if (that.$store.state.productStore.saveError) {
                        // do not close the dialog
                        // display the error
                    }
                    else {
                        // close the dialog
                        that.cancelEditProduct();
                    }
                }
            });
        },
        formatCurrency(value) {
            return formatters.formatCurrency(value);
        },
        departmentChanged(){
            this.editedProduct.CategoryID = undefined;
        },
        calculateCostPerUnit() {
            if(this.editedProduct.Quantity && this.editedProduct.Quantity > 0 && this.editedProduct.CostPrice) {
                this.editedProduct.CostPerUnit = (this.editedProduct.CostPrice / this.editedProduct.Quantity).toFixed(2);
            }
        }
    },
    created() {
        this.loadProducts();

        if (this.categories.length <= 0) {
            this.loadCategories();
        }
        if (this.departments.length <= 0) {
            this.loadDepartments();
        }
    }
};
</script>

<style>
    
</style>
